import { render, staticRenderFns } from "./ExpertYearAssessEdit.vue?vue&type=template&id=113e2607&scoped=true"
import script from "./ExpertYearAssessEdit.vue?vue&type=script&lang=js"
export * from "./ExpertYearAssessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e2607",
  null
  
)

export default component.exports